import React, {useEffect, useRef, useState} from 'react';
import { Row, Col, Card, Button, Form } from 'react-bootstrap';
import { format, parseISO } from 'date-fns';
import {toast} from "react-toastify";
import {add, listUnusedPlayers} from '../../../lib/api/license';

const formatBirthDate = value => {
  if (!value) return '';

  const date = typeof value === 'string' ? parseISO(value.slice(0, 10)) : new Date(value);
  return Number.isNaN(date.getTime()) ? '' : format(date, 'dd.MM.yy');
};

export function Add({ initialData, onClose, onSave }) {
  console.clear();
  console.log('initialData',initialData)
  const [license, setLicense] = useState(initialData);
  const [players, setPlayers] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const isSubmitting = useRef(false);

  useEffect(() => {
    (async () => {
      const resPlayers = await listUnusedPlayers(license.document_guid);
      console.log('resPlayers',resPlayers)
      setPlayers(resPlayers);
    })();
  }, [license]);

  const handleSubmit = async event => {
    event.preventDefault();
    if (isSubmitting.current) return;

    const formData = new FormData(event.currentTarget);
    const obj = Object.fromEntries(formData.entries());
    const selected = Object.keys(obj)
        .filter(key => obj[key] === 'true')
        .map(Number);

    if (selected.length === 0) return
    isSubmitting.current = true;
    setIsSaving(true);
    try {
      await add({"player_entities_ids": selected}, license.document_guid);
    }catch (err) {
      isSubmitting.current = false;
      setIsSaving(false);
      toast.error(
          <span>
            <p>Došlo je do greške.</p>
            <p>{err.body?.message || err.message}</p>
          </span>
      );
      return;
    }
    onSave();
    onClose();
  };

  return (
      <Card>
        <Card.Body className="bg-body-tertiary">
          <Form
              method="POST"
              encType="multipart/form-data"
              noValidate
              onSubmit={handleSubmit}
          >
            <Row className="mb-3">
              <Form.Group as={Col} md="12" controlId="clubs-list">
                <Row>
                  <Col md={6}>
                    {players.slice(0, Math.ceil(players.length / 2)).map((item) => (
                        <div className="form-check" key={item.entities_id}>
                          <input
                              className="form-check-input"
                              type="checkbox"
                              disabled={isSaving}
                              name={item.entities_id}
                              value={true}
                              id={item.entities_id}
                          />
                          <label className="form-check-label" htmlFor={`check_${item.entities_id}`}>
                            {item.name} {item.last_name}
                            <small>{item.date_of_birth ? ` - ${formatBirthDate(item.date_of_birth)}` : ''} ({item.selection_name})</small>
                          </label>
                        </div>
                    ))}
                  </Col>
                  <Col md={6}>
                    {players.slice(Math.ceil(players.length / 2)).map((item) => (
                        <div className="form-check" key={item.entities_id}>
                          <input
                              className="form-check-input"
                              type="checkbox"
                              disabled={isSaving}
                              name={item.entities_id}
                              value={true}
                              id={item.entities_id}
                          />
                          <label className="form-check-label" htmlFor={`check_${item.entities_id}`}>
                            {item.name} {item.last_name}
                            <small>{item.date_of_birth ? ` - ${formatBirthDate(item.date_of_birth)}` : ''} ({item.selection_name})</small>
                          </label>
                        </div>
                    ))}
                  </Col>
                </Row>
              </Form.Group>
            </Row>




            <Button type="submit" disabled={isSaving} aria-busy={isSaving}>
              {isSaving ? 'Čuvanje…' : 'Sačuvaj'}
            </Button>
          </Form>
        </Card.Body>
      </Card>
  );
}
